import {Select, SelectProps} from "@mantine/core";
import {Provinces} from "./Provinces";

interface Props extends Omit<SelectProps, "data"> {

}

function ChinaProvince(props: Props) {

    function serializeProvinces() {
        return Provinces.map((prov) => ({value: prov.code, label: `${prov.name} (${prov.native})`}))
    }

    return (
        <Select {...props} data={serializeProvinces()}/>
    )

}

export default ChinaProvince;